<template>
    <!-- 登录 -->
    <div class="logins">
        <div class="logleft">
            <img :src="$img(txt)" alt="" />
        </div>
        <div class="tops">
            <div class="gb flx alc" @click="toIndex">
                <span>返回首页</span>
            </div>
            <div class="topTitle">
                注册账号
            </div>
            <!-- <div class="toptap flx alc jsc">
                <div class="ttitem cursor" @click="cur = 0">
                    <div class="ttname" :class="cur == 0?'acwo' : ''" >
                        个人注册
                    </div>
                    <div class="ttheng" v-if="cur == 0"></div>
                </div>
                <div class="ttitem cursor" @click="cur = 1">
                    <div class="ttname" :class="cur == 1?'acwo' : ''">
                        商家注册
                    </div>
                    <div class="ttheng" v-if="cur == 1"></div>
                </div>
            </div> -->
            <div class="ips">
                <!-- ===== 新增：欺骗浏览器的隐藏假输入框，放在最顶部 ===== -->
                <input type="text" style="position:absolute;opacity:0;width:0;height:0;">
                <input type="password" style="position:absolute;opacity:0;width:0;height:0;">

                <div class="plItem flx alc">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('phoneIcon.png')" alt="" />
                        <!-- 手机号：autocomplete="off"，自定义name -->
                        <input type="text" name="reg_phone" autocomplete="off" placeholder="请输入手机号码" maxlength="11"
                            v-model="phone" />
                    </div>
                </div>
                <div class="plItem flx alc jsb" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb" style="width: 245px;">
                        <img :src="$Localimg('gurdIcon.png')" alt="" />
                        <!-- 验证码：autocomplete="one-time-code" -->
                        <input type="text" name="reg_code" autocomplete="one-time-code" placeholder="请输入短信验证码"
                            maxlength="6" v-model="code" />
                    </div>
                    <div class="sendCode cursor" @click="sendCode">
                        {{ isCountDown ? `${count} 秒后重发` : '获取验证码' }}
                    </div>
                </div>
                <div class="plItem" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('locaIcon.png')" alt="" />
                        <!-- 注册密码重点：autocomplete="new-password" -->
                        <input :type="inpType" name="reg_pwd" autocomplete="new-password" placeholder="请设置密码"
                            v-model="pwd" />
                        <img class="eyes" :src="$Localimg('eyeIcon.png')" v-if="inpType == 'password'"
                            @click="inpType = 'text'" alt="">
                        <img class="eyes" :src="$Localimg('openeye.png')" v-if="inpType == 'text'"
                            @click="inpType = 'password'" alt="">
                    </div>
                    <div class="tpis">密码提示：长度 8~10 位，必须同时包含字母（大小写不限）和数字，不支持特殊符号。</div>
                </div>
                <div class="plItem flx alc" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('locaIcon.png')" alt="" />
                        <!-- 确认密码同样 new-password -->
                        <input :type="inpType1" name="reg_pwd2" autocomplete="new-password" placeholder="请再次确认密码"
                            v-model="pwd2" />
                        <img class="eyes" :src="$Localimg('eyeIcon.png')" v-if="inpType1 == 'password'"
                            @click="inpType1 = 'text'" alt="">
                        <img class="eyes" :src="$Localimg('openeye.png')" v-if="inpType1 == 'text'"
                            @click="inpType1 = 'password'" alt="">
                    </div>
                </div>
                <div class="flx alc rever">
                    <span class="bword cursor" @click="tolog">去登录</span> <span class="norword">已有账号? </span>
                </div>
                <div class="Loginbtn cursor" style="margin-top: 23px;" @click="toLogin">
                    立即注册
                </div>
                <div class="rules flx alc jsc" style="margin-top: 30px;">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="toRule(2)">《隐私政策》</b> 和 <b
                            class="cursor" style="color:#007AFF" @click="toRule(1)">《用户协议》</b>
                    </div>
                </div>
            </div>
        </div>
        <div @click="toJump" v-text="ttp" class="ttp"></div>
    </div>

</template>


<script>
    import {
        getConfig,
        sendCode,
        phoneLogin,
        codeLogin,
        userInfo,
        registers
    } from "@/api/index.js"
    export default {
        name: 'Register',
        props: ['type'],
        data() {
            return {
                showLogin: false,
                inpType: "password",
                inpType1: 'password',
                logo: "",
                cur: 0,
                phone: "",
                codeTxct: "获取验证码",
                code: "",
                sending: false,
                hasRead: false,
                isCountDown: false, // 是否正在倒计时
                count: 60, // 倒计时秒数
                timer: null, // 定时器
                pwd: "",
                pwd2: "",
                show: false,
                isLogin: false,
                qrcode: "",
                txt: "",
                ttp: ''
            }
        },
        watch: {
            'type'(newVal) {
                // 只监听form里面name字段变化
                console.log("newVal", this.type)
            }
        },
        mounted() {
            // this.nelog()
            this.cur = this.type
            let that = this
            getConfig().then((res) => {
                if (res.code == 1) {
                    that.txt = res.data.bg_login_text
                    that.ttp = res.data.beian
                }
            })
        },
        methods: {
            toJump() {
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            },
            tolog() {
                this.$emit("logss")
            },
            toLogin() {
                let that = this
                if (that.hasRead == true) {
                    let data = {}
                    data.type = 1
                    data.tel = that.phone
                    data.pwd = that.pwd
                    data.code = that.code
                    data.pwd2 = that.pwd2
                    registers(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            localStorage.setItem('shop_token', res.data.token)
                            that.tolog()
                            this.$message.success(res.msg)
                        }
                        if (res.code == -4) {
                            localStorage.setItem('shop_token', res.data.token)
                            that.$emit("verifys")
                            // that.$message.error(res.msg)
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })
                } else {
                    that.$message.warning('请勾选并仔细阅读《隐私政策》和《用户协议》')
                }
            },
            closedo() {
                this.$emit("cal", 1)
            },
            changeType() {
                let that = this
                if (that.inpType == 'password') {
                    that.inpType = 'text'
                } else {
                    that.inpType = 'password'
                }
            },
            toRule(e) {
                window.open('https://two.hrxsl.com/rules?type=' + e + '&t=' + Date.now(), '_blank');
            },
            toIndex() {
                window.location.href = "https://two.hrxsl.com"
            },
            // 发送验证码
            sendCode() {
                let that = this
                // 简单手机号校验
                if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                // 模拟发送验证码接口
                console.log('发送验证码到：', this.phone)
                if (this.isCountDown == false) {
                    let data = {}
                    data.tel = that.phone
                    data.type = 2
                    sendCode(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            // 开始倒计时
                            this.isCountDown = true
                            let time = this.count
                            this.timer = setInterval(() => {
                                time--
                                this.count = time
                                if (time <= 0) {
                                    clearInterval(this.timer)
                                    this.isCountDown = false
                                    this.count = 60
                                }
                            }, 1000)
                            this.$message.success('验证码已发送')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })

                }
            },
        }
    }
</script>
<style scoped>
    .gb {
        color: #007AFF;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: -30px;
    }

    .ttp {
        position: absolute;
        bottom: 40px;
        text-align: center;
        width: 100%;
        color: #999;
        font-size: 14px;
    }

    .logleft {
        position: absolute;
        left: 15%;
        top: 40%;
        transform: translateY(-50%);
        width: 40%;
    }

    .logleft img {
        width: 100%;
        height: auto;
    }

    .tpis {
        font-size: 14px;
        color: #666;
        text-align: left;
        margin-top: 8px;
        box-sizing: border-box;
        padding: 0 6px;
    }

    .acwo {
        color: #007AFF !important;
    }

    .norword {
        font-weight: 500;
        font-size: 14px;
        color: #999999;
    }

    .ips {
        box-sizing: border-box;
        padding: 30px;
    }

    .toptap {
        border-bottom: 1px solid #D9D9D9;
        margin-top: 24px;
    }

    .ttitem {
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        padding: 12px 0 0;
        position: relative;
        flex: 1;
        text-align: center;
    }

    .ttname {
        margin-bottom: 12px;
    }

    .ttheng {
        width: 22px;
        height: 2px;
        background: #007AFF;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
    }

    .tops {

        width: 420px;
        background: #fff;
        position: absolute;
        right: 5%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1.05);
        border-radius: 20px;
    }

    .topTitle {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        box-sizing: border-box;
        padding: 30px 0 0;
        text-align: center;
    }

    .sh {
        color: #BEBEBE;
        font-size: 12px;
        margin: 0 12px;
    }

    .wechatlogin {
        margin-top: 18px;
    }

    .bword {
        font-weight: 500;
        font-size: 14px;
        color: #007AFF;
    }

    .rever {
        text-align: right;
        flex-direction: row-reverse;
        margin-top: 16px;
    }

    .pzhanghao {
        margin-top: 16px;
    }

    .pztitle {
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        margin-bottom: 12px;
    }

    .sarule {
        margin-top: 27px;
        font-size: 12px;
        color: #333;
    }

    .permethods {
        margin: 20px auto 0;
        box-sizing: border-box;
        padding: 0 54px;
    }

    .peitem img {
        width: 30px;
        height: 30px;
        margin-bottom: 8px;
    }

    .peitem {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .otname {
        margin: 0 24px;
        font-weight: 600;
        font-size: 12px;
        color: #73829D;
    }

    .otleft,
    .otright {
        width: 94px;
        height: 1px;
        background: #E9E9E9;
    }

    .regi {
        text-align: center;
        font-size: 12px;
        color: #007AFF;
        margin-top: 70px;
    }

    .logtips img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }

    .logtips {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .wechat {
        margin-top: 40px;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
    }

    .wechat img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .Loginbtn {
        margin-bottom: 20px;
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 63px;
    }

    .sendCode {
        width: 91px;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 12px;
        color: #666666;
        font-weight: 500;
    }

    .phoneInp img {
        width: 18px;
        height: 18px;
    }

    .phoneInp input {
        flex: 1;
        box-sizing: border-box;
        padding: 0 8px;
        height: 100%;
        font-size: 14px;
        border: none !important;
        outline: none !important;
        background: transparent !important;
    }

    .phoneInp {
        width: 100%;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .phoneLogin {
        margin-top: 50px;
    }

    .cmActive {
        font-weight: 500 !important;
        font-size: 20px !important;
        color: #007AFF !important;
    }

    .heng {
        width: 32px;
        height: 3px;
        background: #007AFF;
        border-radius: 2px;
        margin: 10px auto 0;
    }

    .changeMetohds {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .cmName {
        font-weight: 500;
        font-size: 20px;
        color: #999999;
    }

    .cmItem {
        margin: 0 24px;
        cursor: pointer;
    }

    .closeBtn {
        position: absolute;
        right: -50px;
        top: 0;
        cursor: pointer;
    }

    .logMethod img {
        width: 100%;
        height: 100%;
    }

    .logMethod {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 55px;
        height: 55px;
    }

    .logContent {
        width: 420px;
        /* height: 711px; */
        background: #fff;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        box-sizing: border-box;
        padding: 30px;
    }

    .logins {
        /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        background: url('https://shop.hrxsl.com/images/loginback.png') no-repeat;
        background-size: 100% 100%;
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 116 !important;
    }


    .pubItem {
        font-weight: 500;
        font-size: 16px;
        color: #151515;
        padding: 0 24px;
        cursor: pointer;
    }

    .el-header {
        padding: 0 !important;
    }

    .register {
        width: 83px;
        height: 115px;
        background: #007AFF;
        text-align: center;
        line-height: 115px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 115px;
        cursor: pointer;
    }

    .shu {
        width: 1px;
        height: 14px;
        background: #D9D9D9;
    }

    .pubs {
        flex: 1;
        justify-content: flex-end;
    }

    .search {
        margin-left: 259px;
    }

    .inp {
        width: 344px;
        height: 34px;
        border: 1px solid #007AFF;
    }

    .inp input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 13px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .searchBtn {
        width: 86px;
        height: 34px;
        background: #007AFF;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #007AFF;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        font-size: 13px;
        color: #FFFFFF;
    }

    .hea {
        background: pink;
        height: 115px !important;
        background: #FFFFFF;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 230px !important;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 111;
        width: 100%;
    }

    .logo {
        width: 162px;
        height: 55px;

    }

    .logo img {
        width: 100%;
        height: 100%;
    }
    
    /* 浏览器自动填充背景覆盖 */
    .phoneInp input:-webkit-autofill,
    .phoneInp input:-webkit-autofill:hover,
    .phoneInp input:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0px 1000px #F6F7F9 inset !important;
      -webkit-text-fill-color: #333 !important;
    }
</style>